import React, { useEffect, useState } from "react";
import BodyWrapper from "../utils/BodyWrapper";
import { useNavigate, redirect } from "react-router-dom";
import { API } from "../App";

function AdminPanel() {
  const navigate = useNavigate();
  const [sponsors, setSponsors] = useState([]);
  const [categories, setCategories] = useState([]);
  const [users, setUsers] = useState([]);
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const fetchPosts = async () => {
    const categorias = categories.map((cat) => {
      return new Promise(async (resolve, reject) => {
        try {
          resolve({
            title: cat.title,
            [cat.title.toLowerCase()]: await getPosts(
              cat.id,
              cat.title.toLowerCase()
            ),
          });
        } catch (err) {
          console.log(err.message);
          reject(err.message);
        }
      });
    });
    Promise.all(categorias).then((result) => {
      setPosts(result);
      setTimeout(() => setLoading(false), 1000);
    });
  };
  const getSponsors = async () => {
    const sponsorsResponse = await fetch(`${API}/api/admin/sp/list`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage["tk"]}`,
      },
    })
      .then((res) => res.json())
      .catch((err) => console.log(err));
    if (!sponsorsResponse.message) {
      setSponsors(sponsorsResponse);
    } else {
      return redirect("/admin");
    }
  };
  const getPosts = async (postId) => {
    const postsResponse = await fetch(
      `${API}/api/admin/categories/${postId}/publications`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage["tk"]}`,
        },
      }
    )
      .then((res) => res.json())
      .catch((err) => console.log(err));
    if (postsResponse) {
      return postsResponse;
    } else {
      return redirect("/admin");
    }
  };
  const getCategories = async () => {
    const categoriesResponse = await fetch(`${API}/api/admin/categories/list`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage["tk"]}`,
      },
    })
      .then((res) => res.json())
      .catch((err) => console.log(err));
    if (!categoriesResponse.message) {
      setCategories(categoriesResponse);
    } else {
      return redirect("/admin");
    }
  };
  const getUsers = async () => {
    const usersResponse = await fetch(`${API}/api/admin/users/list`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage["tk"]}`,
      },
    })
      .then((res) => res.json())
      .catch((err) => console.log(err));
    setUsers(usersResponse);
  };
  const handleDelete = async (primaryKey, entity, foreignKey) => {
    if (entity === "categories") {
    } else if (entity === "posts") {
    } else if (entity === "sponsors") {
      const deleteResponse = await fetch(
        `${API}/api/admin/sp/delete-sponsor/${primaryKey}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${localStorage["tk"]}`,
          },
        }
      )
        .then((res) => res.json())
        .catch((err) => console.log(err));
      if (typeof deleteResponse === "string") {
        const newSponsors = [
          ...sponsors.filter((sp) => sp.id !== deleteResponse),
        ];
        setSponsors(newSponsors);
      }
    }
  };
  useEffect(() => {
    setLoading(true);
    getSponsors();
    getUsers();
    getCategories();
  }, []);
  useEffect(() => {
    fetchPosts();
  }, [categories]);
  return (
    <>
      <BodyWrapper>
        {loading ? (
          <h1 style={{ color: "white" }}>Cargando contenido...</h1>
        ) : (
          <div className="adminpanel">
            <ul style={{ color: "white" }}>
              <li>
                <h1>Sponsors</h1>
                {
                  <ul>
                    {sponsors?.map((sp) => (
                      <li key={`${sp.name}-${sp.id}`}>
                        <span>{sp.name} </span>
                        <button>Editar</button>
                        <button onClick={() => handleDelete(sp.id, "sponsors")}>
                          Eliminar
                        </button>
                      </li>
                    ))}
                  </ul>
                }
                <button
                  type="button"
                  onClick={() => navigate("/admin/panel/sponsors/new")}
                >
                  Crear
                </button>
              </li>
              <li>
                <h1>Categorias</h1>
                {
                  <ul>
                    {categories?.map((cat) => (
                      <li key={`${cat.title}-${cat.id}`}>
                        <span>{cat.title} </span>
                        <button>Editar</button>
                        <button
                          onClick={() => handleDelete(cat.id, "categories")}
                        >
                          Eliminar
                        </button>
                      </li>
                    ))}
                  </ul>
                }
                <button onClick={() => navigate("/admin/panel/categories/new")}>
                  Crear
                </button>
              </li>
              <li>
                <h1>Usuarios</h1>
                {
                  <ul>
                    {users?.map((user) => (
                      <li key={`user-${user.id}`}>
                        <span>{`${user.firstName} ${user.lastName}`} </span>
                        <button>Editar</button>
                        <button>Eliminar</button>
                      </li>
                    ))}
                  </ul>
                }
                <button>Crear</button>
              </li>
              <li>
                <h1>Publicaciones</h1>
                {posts.map((cat, i) => (
                  <div key={`${cat.title.toLowerCase()}-${i}`}>
                    <h3>{`${cat.title}`}</h3>
                    <ul>
                      {cat.title &&
                        cat[cat.title.toLowerCase()]?.map((post, i) => (
                          <li key={`${post.id}-${i}`}>
                            <span>{post.title} </span>
                            <button>Editar</button>
                            <button
                              onClick={() =>
                                handleDelete(post.id, "posts", cat.id)
                              }
                            >
                              Eliminar
                            </button>
                          </li>
                        ))}
                    </ul>
                  </div>
                ))}
                <button onClick={() => navigate("/admin/panel/posts/new")}>
                  Crear
                </button>
              </li>
            </ul>
          </div>
        )}
      </BodyWrapper>
    </>
  );
}

export default AdminPanel;
